import React from 'react';

import Map from 'components/map/Map';
import StreetView from 'components/map/StreetView';
import { apiKeyGMap } from 'components/map/utils';
import { Button } from 'ui-kit';

import { GalleryComponent } from './GalleryComponent';

const STATIC_CENTER = { lat: 40.758, lng: -73.985 };

const mkStaticUrl = (lat: number, lng: number, type: 'map' | 'street') =>
  `https://maps.googleapis.com/maps/api/staticmap?key=${apiKeyGMap}` +
  `&center=${lat},${lng}&zoom=${type === 'map' ? 14 : 18}&size=640x360` +
  (type === 'street' ? `&maptype=satellite` : '');

interface Props {
  pdfMode?: boolean;
}

export const GalleryMapView: React.FC<Props> = ({ pdfMode = false }) => {
  const [viewMode, setViewMode] = React.useState<number>(0);

  if (pdfMode) {
    return (
      <div className="space-y-4">
        <GalleryComponent />
        <img
          src={mkStaticUrl(STATIC_CENTER.lat, STATIC_CENTER.lng, 'map')}
          alt="Static Map"
          onLoad={() => console.log('Map image loaded')}
          crossOrigin="anonymous"
        />
        <img
          src={mkStaticUrl(STATIC_CENTER.lat, STATIC_CENTER.lng, 'street')}
          alt="Static Street View"
          onLoad={() => console.log('StreetView loaded')}
          crossOrigin="anonymous"
        />
      </div>
    );
  }

  return (
    <div className="w-full">
      {viewMode === 0 && <GalleryComponent />}
      {viewMode === 1 && <Map />}
      {viewMode === 2 && <StreetView />}
      <div className="mb-6 mt-6 flex items-center justify-start gap-2">
        {['Gallery View', 'Map View', 'Street View'].map((item, idx) => (
          <Button
            label={'gallery'}
            className="!h-[24px] !min-h-[24px] "
            type="secondary_light"
            key={item}
            onClick={() => setViewMode(idx)}
            size="small"
          >
            {item}
          </Button>
        ))}
      </div>
    </div>
  );
};
